import React from 'react';
import ctrl from 'controllers/cotacao-ctrl';
import utils from 'utils/utils';
import Row from 'components/row';
import Col from 'components/col';
import Button from 'components/button';
import Icon from 'components/icon';
import FormInput from 'components/form-input';
import FormTextArea from 'components/form-textarea';
import NumberInput from 'components/form-number-input';
import AvisoPreco from './aviso-preco';
import AvisoQuantidade from './aviso-quantidade';
import sysCtrl from 'controllers/sys-ctrl';

module.exports = React.createClass({

  handleSubmit(ev){
    ev.preventDefault();
  },

  renderItemPreco(prazo,index){
    var refName;
    if (index == 0) refName = 'editPreco';
    return (<NumberInput ref={refName} key={prazo} size="sm-3" valueLink={ctrl.linkState("preco"+prazo)} label={"$ "+prazo+" dias (2)"} decPlaces={2} />);
  },

  render(){

    var item = this.props.item;
    var errorAlert;

    if (ctrl.data.edit.errorMessage) {
      errorAlert = (
        <Row>
          <Col size="sm-12">
            <div className="alert alert-danger" onClick={ctrl.setEditErrorMessage.bind(this,'')}>
              {ctrl.data.edit.errorMessage}
            </div>
          </Col>
        </Row>
      );
    }

    return (
      <div className="item-detail">
        <form onSubmit={this.handleSubmit}>
          <Row>
            <FormInput size="sm-3" value={item.codigo} readOnly={true} label="Código"/>
            <FormInput size="sm-9" value={item.descricao} readOnly={true} label="Descrição" />
          </Row>
          <Row>
            <FormInput size="sm-6" value={item.grupo} readOnly={true} label="Grupo"/>
            <FormInput size="sm-6" value={item.marca} readOnly={true} label="Marca" />
          </Row>
          <Row>
            <FormInput size="sm-4" value={item.unidade} readOnly={true} label="Unid."/>
            <FormInput size="sm-4" value={item.embalagem} readOnly={true} label="Emb." />
            <FormInput size="sm-4" value={item.qtCompra} readOnly={true} label="Qt.Comprar (1)" labelClass="aviso-quant-label"/>
          </Row>
          <Row>
            {sysCtrl.data.condicoesPreco.map(this.renderItemPreco)}
          </Row>
          <Row>
            <FormTextArea size="sm-12" valueLink={ctrl.linkState("obs")} label="Observações" rows="3" />
          </Row>
          <AvisoQuantidade marker="1" />
          <AvisoPreco marker="2"/>
          {errorAlert}
        </form>
      </div>
    );
  }
});


/** WEBPACK FOOTER **
 ** ./src/views/cotacao/cotacao-det-item.js
 **/